var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-button',{staticStyle:{"height":"40px"},attrs:{"size":"medium","type":"primary","plain":""},on:{"click":function($event){return _vm.exportExcel(_vm.$parent.searchQuery)}}},[_vm._v("\n    导出\n  ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }